import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';

# Editing Templates

## <v-icon>mdi-tune</v-icon> Template Variables

Note: These variables are created by the Template (Ventuz Scene Designer), this is simply where we control these variables in CanvasPro.

This is where you can set the default variables for this Template.
Any Scene (based on this template) will use the these settings, unless changed on that Scene.

{/* ### Filter Variables - EDITOR NOTE: This was removed from CPRO

You can filter the variables to only show the ones matching your search criteria. */}

## <v-icon>mdi-rename-box</v-icon> Template Details

### Name

The name of your Template.

### Description

The description of your Template.

## <v-icon>mdi-image-search</v-icon> Template Related Files

### Upload Thumbnail

Choose an image from your device to use instead of the default thumbnail in CanvasPro.

### Change icon

Select from a variety of Icons to use instead of the default icon in CanvasPro.

## <v-icon>mdi-motion-play-outline</v-icon> Template Play Conditions

This is where you can add Play Conditions to the template. These will be applied to any Scene that uses this template.

{/* ## <v-icon>mdi-share-all</v-icon> Template Triggers - EDITOR NOTE: This was removed from CPRO

This is where you set the default triggers for this Template. These defaults can be overridden by the Scene Triggers.

Triggers allow you to do various actions when any scene using this template is live. */}

## <v-icon>mdi-engine</v-icon> Template Engine Behavior

These options affect how the engine loads content, the default options are always recommended.

### Prioritize Memory Usage

CanvasPro will attempt to remove this Template from memory when it is not in use. Keeping a Template in memory will make it load faster, but will use more memory.

### Self Swap Mode

This is the default for custom Templates. In this mode, we presume that the Template will handle its own swapping of content. And not use CanvasPro built-in transitions.
This generally means there will only be one instance of a Template loaded. (Unless Cue/Take is used while this scene is live)

### Load Cue/Take on Startup

This preemptively loads an extra instance of this Template on startup, for use in Cue/Take workflows.

### Ignore Empty ScenePorts (Only available for Nested Templates)

When switching Scenes with this Template, if the next Scene has an empty ScenePort, the current Sub Scene in that port remains active. This is useful for defining Scene variations by specifying only the differences.

## <v-icon>mdi-book-clock</v-icon> Template Load Timings

Displays the Averages of the last 20 loads of this Template.

Useful for debugging performance issues, with slow loading Templates.

## <v-icon>mdi-file-replace</v-icon> Template Upgrade (Only available for Custom Templates)

Enables you to upgrade a template to a newer version.

{/* Editor Note: Where is Template Upgrade? */}
{/* ## <v-icon>mdi-file-replace</v-icon> Template Upgrade */}

## <v-icon>mdi-tag</v-icon> Template Tags

This is where you can select all the Tags you would like to assign to this Template. When creating a scene from an asset in a queue, the template chosen will be based on these tags. For example, when creating a scene from an asset that has a "Video" tag, the "Video" template is used because it also has a "Video" tag.

## Save

To save your changes, click <ExampleSaveButton /> (bottom right).

To cancel your changes, click <ExampleCloseButton /> (top right).
